<script lang="ts">
    import { Button } from "sveltestrap";
    import AppWraper from "../components/AppWraper.svelte";
    import { recordsLostObjectsService, usersService } from "../services";
    import { dateInputFormatter } from "../services/Functions";
    import { v4 as uuidv4 } from 'uuid';
    import { User } from "../Model/User";
    import FilterRegisterLostObject from "../components/FilterRegisterLostObject.svelte";
    import RegisterModalLostObject from "../components/RegisterModalLostObject.svelte";
    import { RecordLostObject } from "../Model/RecordLostObject";
    import ParamName from "../components/ParamName.svelte";

    let editRegister: RecordLostObject = null;
    let registers: RecordLostObject[];
    let offset = 0;
    let limit = 25;
    let searchFilter = {
      register : null,
      selectRegister : null,
      selectObject : null,
      date : null
    };
    let user = null;

    let startDate = null;
    let endDate = null;
    let newRegisters = false;
    
    let date = new Date();

    $: loadInputDate();

    async function loadRegisters(searchFilter = null): Promise<void> {
        let opts = {
            offset : offset,
            limit : limit,
            filters : {
                search: searchFilter
            }
        }

        registers = await recordsLostObjectsService.findRegisters(opts);

        user = await usersService.findActualUser();
    }

    async function newRegister(){

        newRegisters = true;

        let actualUser = new User(user);

        editRegister = new RecordLostObject({
                id: uuidv4(),
                inRegister: null,
                inDate: null,
                outRegister: null,
                outDate: null,
                agentReceptorId: null,
                agentDeliveryId: null,
                deliveredBy: null,
                placeFound: null,
                objType: null,
                objImage: null,
                observations: ' ',
                userId: '' + actualUser.id,
            })
    }

    function registerUpdate(register: RecordLostObject): void {
        let registerAct = registers.find(u => u.id == register.id)

        if (registerAct) {
            registerAct = register
            registers = registers;
        }else{
            registers = [...registers, register];
        }
    }

    function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth()+1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()
        let day = date.getDate()

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];
        
        searchFilter.selectRegister = 'both';
        searchFilter.date = selectedDates;

        loadRegisters(JSON.stringify(searchFilter));
    }

</script>

<style>

</style>

<AppWraper>
    <div class="container-fluid p-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-9 mb-3">
                    <div class="text-start">
                        <h3>Registros de Objetos Perdidos</h3>
                    </div>
                </div>
                <div class="col-12 col-sm-3 mb-3">
                    <div class="text-end">
                        <Button color="success" on:click={() => newRegister()}>
                            Nuevo Registro
                        </Button>
                    </div>
                </div>
            </div>
            
            <FilterRegisterLostObject bind:searchFilterComponent={searchFilter} on:load={() => loadRegisters(JSON.stringify(searchFilter))}/>

            {#if registers}
            <div class="row mt-3">
                <div class="col-12">
                    {#if registers?.length}
                    <table class="table">
                        <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Entrada</th>
                                    <th scope="col">Fecha Entrada</th>
                                    <th scope="col">Salida</th>
                                    <th scope="col">Fecha Salida</th>
                                    <th scope="col">Objeto</th>
                                </tr>
                        </thead>
                        <tbody>
                            {#each registers as register, index }
                                <tr>
                                    <th scope="row">{index + 1}</th>
                                    <td>
                                        {#if register.inRegister}
                                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                                            <span class='btn btn-link' on:click={() => {editRegister = register; newRegisters = false}}>
                                                {register.inRegister}
                                            </span>
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.inDate}
                                            {dateInputFormatter(register.inDate)}
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.outRegister}
                                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                                            <span class='btn btn-link' on:click={() => {editRegister = register; newRegisters = false}}>
                                                {register.outRegister}
                                            </span>
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.outDate}
                                            {dateInputFormatter(register.outDate)}
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.objType}
                                            <ParamName id={register.objType} />
                                        {/if}
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                    {:else}
                        <div class="text-center pt-5">
                            <hr>
                            <h3>No hay registros para mostrar</h3>
                        </div>
                    {/if}
                </div>
            </div>
        {/if}
        
        
        </div>
    </div>
    <RegisterModalLostObject register={editRegister} bind:newRegister={newRegisters} on:registerUpdate={() => registerUpdate(editRegister)}/>

</AppWraper>



